<div class="popup-model popup-md shadow top">
  <div class="d-flex justify-content-between align-items-center pink-header p-2">
    <h5 class="flex-grow-1 text-center mt-1">{{'EXPORT.SELECT_FILE_TYPE' | translate}}</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="cancel()">
        <img src="assets/icon/close.svg" alt="Close" />
      </button>
    </div>
  </div>
  <div class="p-4">
    <h6 class="mb-3">{{'EXPORT.CHOOSE_FORMATS' | translate}}</h6>
    <div class="file-type-options">
      <div class="file-type-card" 
           [class.selected]="isSelected(FileExportType.STR)" 
           (click)="toggleFileType(FileExportType.STR)">
        <div class="file-type-icon">
          <i class="fas fa-file-alt"></i>
        </div>
        <div class="file-type-info">
          <h6>STR</h6>
          <p class="text-muted">{{'EXPORT.STR_DESCRIPTION' | translate}}</p>
        </div>
        <div class="file-type-check" *ngIf="isSelected(FileExportType.STR)">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>

      <div class="file-type-card" 
           [class.selected]="isSelected(FileExportType.DM4)" 
           (click)="toggleFileType(FileExportType.DM4)">
        <div class="file-type-icon">
          <i class="fas fa-file-code"></i>
        </div>
        <div class="file-type-info">
          <h6>DM4</h6>
          <p class="text-muted">{{'EXPORT.DM4_DESCRIPTION' | translate}}</p>
        </div>
        <div class="file-type-check" *ngIf="isSelected(FileExportType.DM4)">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>

      <div class="file-type-card"
           [class.selected]="isSelected(FileExportType.DXF)"
           (click)="toggleFileType(FileExportType.DXF)">
        <div class="file-type-icon">
          <i class="fas fa-file-image"></i>
        </div>
        <div class="file-type-info">
          <h6>DXF</h6>
          <p class="text-muted">{{'EXPORT.DXF_DESCRIPTION' | translate}}</p>
        </div>
        <div class="file-type-check" *ngIf="isSelected(FileExportType.DXF)">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>

      <div class="dxf-version-select mt-2" *ngIf="isDxfSelected()">
        <label class="form-label">{{'EXPORT.DXF_VERSION' | translate}}</label>
        <select class="form-select form-select-sm" [(ngModel)]="selectedDxfVersion">
          <option *ngFor="let v of dxfVersions" [ngValue]="v.value">{{v.label}}</option>
        </select>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{'GLOBAL.ANNULER' | translate}}
      </button>
      <button type="button" 
              class="btn btn-primary"
              [disabled]="selectedFileTypes.length === 0"
              (click)="exportFiles()">
        <i class="fas fa-download me-2"></i>{{'EXPORT.EXPORT' | translate}}
        <span *ngIf="selectedFileTypes.length > 0">({{selectedFileTypes.length}})</span>
      </button>
    </div>
  </div>
</div>
